import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const HearingCopyrightApplication = () => {
  const fileStatus = 11;
  const applicationPath = {
    copyright: "/admin/hearing-application-copyright",
    agreement: "/admin/hearing-application-agreement",
  };
  const detailsRoute = "/admin/hearing-copyright-details";
  const pageTitle = "শুনানীর নথি";
  return (
    <SubmittedCopyright
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default HearingCopyrightApplication;
